/**
 * Created by glopez on 24/04/17.
 */

// Action types
const ActionTypes = {
        SET_CONFIRM_STATUS: 'SET_CONFIRM_FORM_STATUS',
        SET_CONFIRM_DATA: 'SET_CONFIRM_DATA',
        SET_CONFIRM_ERROR: 'SET_CONFIRM_FORM_ERROR'
    },

    // Status values
    ConfirmStatus = {
        INITIAL: 'initial',
        ERROR: 'error'
    };

/**
 * Set data action.
 *
 * @param {string} title - Title of the modal.
 * @param {string} subtitle - Subtitle of the modal.
 * @param {Function} acceptHandler - Accept button handler.
 * @param {Function} cancelHandler - Cancel button handler.
 * @returns {Object} Action type and the new status.
 */
function setData (title, subtitle, acceptHandler, cancelHandler) {
    return {
        type: ActionTypes.SET_CONFIRM_DATA,
        title,
        subtitle,
        acceptHandler,
        cancelHandler
    };
}

/**
 * Set status action.
 *
 * @param {string} status - New status of the component.
 * @returns {Object} Action type and the new status.
 */
function setStatus (status) {

    return {
        type: ActionTypes.SET_CONFIRM_STATUS,
        status
    };
}

/**
 * Set error action.
 *
 * @param {Object} error - Error object with reason message.
 * @returns {Object} Action type and error object.
 */
function setError (error) {

    return {
        type: ActionTypes.SET_CONFIRM_ERROR,
        error
    };
}

// Exposed elements of the actions file.
export {
    ActionTypes,
    ConfirmStatus,
    setData,
    setStatus,
    setError
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/confirm.js